import configuration from '../../constants/Configuration';
import shapeTypes from '../../constants/ShapeConstants';
import sessionActions from '../../actions/SessionActions';
import storeManager from '../../store/StoreManager';
import exporterUtils from '../../components/utils/ExporterUtils';
import videoUtils from '../../components/utils/VideoUtils';

const slidesPreloader = {
    isPreloaded: false,
    firstPreloadedSlides: configuration.FIRST_PRELOADED_SLIDES,
    slidesImages: [],
    slidesAudios: [],
    slidesAudiosEffects: [],
    slidesVideos: [],
    storySound: undefined,
    storyItem: undefined,
    audioItem: undefined,
    audioEffectItem: undefined,
    currentSlideIndex: 0,
    slidesLength: 0,
    videoElements: [],

    storySoundLoaded: false,
    audioSlideLoaded: false,
    audioSlideEffectLoaded: false,
    videoFromSlideLoaded: false,
    currentSlideAssetsLength: 0,
    currentSlideAssetsCounter: 0,

    preloadAssets(isEditor = false) {
        this.isEditor = isEditor;

        if (this.isPreloaded)
            return;

        exporterUtils.init();
        videoUtils.updateVideoPreloader(true);

        this.createAssetsList();
        this.prepareAssets();
        this.startPreloading();

        this.isPreloaded = true;
    },
    createAssetsList() {
        this.slidesVideos = [];
        this.slidesAudiosEffects = [];
        this.slidesAudios = [];
        this.slidesImages = [];
        this.videoElements = [];
        this.currentSlideIndex = 0;
        this.currentSlideAssetsLength = 0;
        this.currentSlideAssetsCounter = 0;
        this.storySound = undefined;
        this.storyItem = undefined;
        this.audioEffectItem = undefined;
        this.audioEffectItem = undefined;
        this.storySoundLoaded = false;
        this.audioSlideLoaded = false;
        this.audioSlideEffectLoaded = false;
        this.videoFromSlideLoaded = false;

        const state = storeManager.getState();
        const slides = state.production.slides;
        var i;
        var j;
        var shapes;
        var shape;
        var assets = [];
        var slidesAssets;
        const storySound = state.production.storySound;

        if (storySound && storySound.href && storySound.href.length > 0) {
            this.storySound = storySound.href;
        }

        this.slidesLength = slides.length;

        for (i=0; i<slides.length; i++) {
            shapes = slides[i].content;
            slidesAssets = [];

            // add all images from each slide
            for (j=0; j<shapes.length; j++) {
                shape = shapes[j];

                if (shape.type == shapeTypes.BACKGROUND && shape.isVideo)
                    continue;

                //TODO -- should be included the assets from inside of a group
                if (shape.type == shapeTypes.BACKGROUND || shape.type == shapeTypes.CHARACTER || shape.type == shapeTypes.IMAGE) {
                    if (shape.xlinkHref && shape.xlinkHref.length > 0 && assets.indexOf(shape.xlinkHref) < 0) {
                        assets.push(shape.xlinkHref);
                        slidesAssets.push(shape.xlinkHref);
                    }
                }
            }

            this.slidesImages.push(slidesAssets);

            // add audio
            var slideAudio = this.getSlideSoundSource(i);
            this.slidesAudios.push(slideAudio);

            // add audio effects
            var slideAudioEffect = this.getSlideEffectSoundSource(i);
            this.slidesAudiosEffects.push(slideAudioEffect);

            // videos
            this.slidesVideos.push(videoUtils.getSlideVideoHref(i));
        }
    },
    getSlideSoundSource(index) {
        const state = storeManager.getState();
        const slides = state.production.slides;
        const audio = slides[index].sound;
        const audioWav = slides[index].soundWav;

        if (audioWav != undefined && audioWav.length > 0)
            return audioWav;
        else {
            if (audio != undefined && audio.length > 0)
                return audio;
            else
                return '';
        }
    },
    getSlideEffectSoundSource(index) {
        const state = storeManager.getState();
        const slides = state.production.slides;
        const audio = slides[index].soundEffect;

        if (audio != undefined && audio.length > 0)
            return audio;
        else
            return '';
    },
    prepareAssets() {
        if (this.storySound && !this.storyItem) {
            this.storyItem = document.createElement('AUDIO');
            document.body.appendChild(this.storyItem);
            this.storyItem.ondurationchange = this.onStoryItemLoaded.bind(this);
        }

        if (!this.audioItem) {
            this.audioItem = document.createElement('AUDIO');
            document.body.appendChild(this.audioItem);
            this.audioItem.ondurationchange = this.onAudioItemLoaded.bind(this);
        }

        if (!this.audioEffectItem) {
            this.audioEffectItem = document.createElement('AUDIO');
            document.body.appendChild(this.audioEffectItem);
            this.audioEffectItem.ondurationchange = this.onAudioEffectItemLoaded.bind(this);
        }

        const wrapper = document.createElement('div');
        wrapper.id = 'preloaderWrapper';
        wrapper.style.display = 'none';
        document.body.appendChild(wrapper);

        this.videoElements = [];

        var videoWrapper = document.getElementById('multipleVideos');
        videoWrapper.innerHTML = '';

        var i;
        var oldVideo = document.getElementById('videoBackground');
        const currentIndex = storeManager.getState().currentSlide.currentSlideIndex;
        var videoHolder = document.createElement('div');

        videoWrapper.appendChild(videoHolder);

        if (oldVideo)
            oldVideo.style.display = 'none';

        for (i=0; i<this.slidesVideos.length; i++) {
            var videoHref = this.slidesVideos[i];
            var videoElement;

            if (videoHref != '') {
                videoElement = document.createElement('VIDEO');
                videoElement.id = 'video_' + i;
                videoElement.style.position = 'absolute';
                videoElement.style.top = '0px';
                videoElement.style.left = '0px';
                videoElement.style.width = '800px';
                videoElement.style.height = '450px';
                videoElement.className = 'audioItem';
                videoElement.preload = 'auto';
                videoElement.playsinline = true;
                videoElement.ondurationchange = this.onVideoItemLoaded.bind(this);

                if (i != currentIndex)
                    videoElement.style.display = 'none';

                videoHolder.appendChild(videoElement);
            }

            this.videoElements.push(videoElement);
        }
    },
    startPreloading() {
        this.loadAssetsFromSlide(this.currentSlideIndex);
    },
    loadAssetsFromSlide() {
        var index = this.currentSlideIndex;

        if (index >= this.slidesLength) { // finished loading all the slides
            this.endPreloading();
            return;
        }

        this.audioSlideLoaded = false;
        this.audioSlideEffectLoaded = false;
        this.videoFromSlideLoaded = false;

        // story sound
        if (this.storySound && index == 0) {
            this.storySoundLoaded = false;
            this.loadStorySound(this.storySound);
        } else {
            this.storySoundLoaded = true;
        }

        // slide sound
        var slideAudio = this.slidesAudios[index];

        if (slideAudio != '')
            this.loadAudio(slideAudio);
        else
            this.audioSlideLoaded = true;

        // slide sound effect
        var slideAudioEffect = this.slidesAudiosEffects[index];

        if (slideAudioEffect != '')
            this.loadAudioEffect(slideAudioEffect);
        else
            this.audioSlideEffectLoaded = true;

        // video from slide
        var videoHref = this.slidesVideos[index];

        if (videoHref != '')
            this.loadVideo(videoHref, index);
        else
            this.videoFromSlideLoaded = true;

        // all the images from the current slide
        var assetsFromSlide = this.slidesImages[index];
        var i;

        this.currentSlideAssetsLength = assetsFromSlide.length;
        this.currentSlideAssetsCounter = 0;

        for (i=0; i<assetsFromSlide.length; i++) {
            var url = assetsFromSlide[i];
            this.loadImage(url);
        }

        this.checkIfCurrentSlideIsLoaded();
    },

    // audios
    loadStorySound(url) {
        if (this.storyItem) {
            var audio = this.storyItem;
            audio.src = videoUtils.checkCacheBreaker(url);
        }
    },
    onStoryItemLoaded() {
        console.log('Preloaded story sound');

        this.storySoundLoaded = true;
        this.checkIfCurrentSlideIsLoaded();
    },
    loadAudio(url) {
        var audio = this.audioItem;
        audio.src = videoUtils.checkCacheBreaker(url);
    },
    loadAudioEffect(url) {
        var audio = this.audioEffectItem;
        audio.src = videoUtils.checkCacheBreaker(url);
    },
    onAudioItemLoaded() {
        console.log('Preloaded audio');

        this.audioSlideLoaded = true;
        this.checkIfCurrentSlideIsLoaded();
    },
    onAudioEffectItemLoaded() {
        console.log('Preloaded audio effect');

        this.audioSlideEffectLoaded = true;
        this.checkIfCurrentSlideIsLoaded();
    },

    //videos
    loadVideo(url, index) {
        var video = this.videoElements[index];
        video.src = videoUtils.checkCacheBreaker(videoUtils.getCorrectUrl(url));
    },
    onVideoItemLoaded() {
        console.log('Preloaded video');

        if (!this.videoFromSlideLoaded) {
            this.videoFromSlideLoaded = true;
            this.checkIfCurrentSlideIsLoaded();
        } else
            this.videoFromSlideLoaded = true;
    },

    // images
    loadImage(url) {
        var imageObj = new Image();
        var self = this;

        imageObj.onload = function() {
            self.currentSlideAssetsCounter = self.currentSlideAssetsCounter + 1;
            self.checkIfCurrentSlideIsLoaded();
        };

        imageObj.onerror = function() {
            self.currentSlideAssetsCounter = self.currentSlideAssetsCounter + 1;
            self.checkIfCurrentSlideIsLoaded();
        };

        imageObj.src = videoUtils.checkCacheBreaker(url);

        var preloaderWrapper = document.getElementById('preloaderWrapper');
        preloaderWrapper.appendChild(imageObj);
    },

    checkIfCurrentSlideIsLoaded() {
        if (this.storySoundLoaded && this.audioSlideLoaded && this.audioSlideEffectLoaded && this.videoFromSlideLoaded && this.currentSlideAssetsCounter >= this.currentSlideAssetsLength) { // all the content from current slide is loaded
            this.currentSlideIndex = this.currentSlideIndex + 1;

            this.checkPreloader();
            this.loadAssetsFromSlide();
        }
    },
    checkPreloader() {
        if ((this.slidesLength >= this.firstPreloadedSlides && this.currentSlideIndex >= this.firstPreloadedSlides) || (this.slidesLength < this.firstPreloadedSlides  && this.currentSlideIndex >= this.slidesLength)) {
            const store = storeManager.getStore();

            if (!this.isEditor)
                store.dispatch(sessionActions.setCaptionsLoaded());
        }
    },
    endPreloading() {
        videoUtils.updateVideoPreloader(false);

        if (this.storyItem && this.storyItem.parentNode)
            document.body.removeChild(this.storyItem);

        if (this.audioItem && this.audioItem.parentNode)
            document.body.removeChild(this.audioItem);

        if (this.audioEffectItem && this.audioEffectItem.parentNode)
            document.body.removeChild(this.audioEffectItem);

        videoUtils.setInPoints();
    },
    exitPreview() {
        var multipleVideosWrapper = document.getElementById('multipleVideos');

        if (multipleVideosWrapper)
            multipleVideosWrapper.innerHTML = '';

        this.isPreloaded = false;

        var oldVideo = document.getElementById('videoBackground');

        if (oldVideo)
            oldVideo.style.display = 'block';
    }
};

export default slidesPreloader;



/** WEBPACK FOOTER **
 ** ./src/components/utils/SlidesPreloader.js
 **/